import { JobStatus, PartFinderReport } from '@/api/generatedApi';
import { BodyText } from '@/components/BodyText';
import { usePartFinderReportPolling } from '@/hooks/useDataPolling/usePartFinderReportPolling';
import { useEffect, useState } from 'react';
import { getReportElapsedLabel, TimedReport } from './reportElapsedTime';

const TICK_INTERVAL_MS = 1000;

const useNow = (ticking: boolean): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!ticking) {
      return;
    }
    setNow(Date.now());
    const interval = setInterval(() => setNow(Date.now()), TICK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [ticking]);
  return now;
};

export const PartFinderElapsedTime = ({ report }: { report: TimedReport }) => {
  const now = useNow(report.status === JobStatus.RUNNING);
  return <BodyText color='text.secondary'>{getReportElapsedLabel(report, now) ?? '—'}</BodyText>;
};

export const PartFinderElapsedCell = ({ row }: { row: PartFinderReport }) => {
  const report = usePartFinderReportPolling(row);
  return <PartFinderElapsedTime report={report} />;
};
